import React from 'react';
import MortgageForm from "../../../../../components/data-capture/MortgageForm";

function ApplicationForm({section, inExtWindow=true}) {

    let target = section.applicant === 1 ? `applicant1` : `applicant2`
    target = `${target}.debts`
    let jointQuestions = [
         {
            name: 'currency',
            label: 'Currency',
            answer: {
                type: 'text'
            },
            target: `${target}[${section.index}].currency`
        },
    ]
    let questions = [
        [{
            name: 'lender',
            label: 'Bank Name',
            answer: {
                type: 'text',
            },
            target: `${target}[${section.index}].lender`
        }, {
            name: 'accountNumber',
            label: 'IBAN',
            answer: {
                type: 'text',
            },
            target: `${target}[${section.index}].accountNumber`
        }], [

            {
                name: 'isClosed',
                label: 'Is Closed',
                answer: {
                    type: 'select',
                    choices: [
                        {
                            value: true,
                            text: 'Yes'
                        }, {
                            value: false,
                            text: 'No'
                        }
                    ]
                },
                target: `${target}[${section.index}].isClosed`
            }, {
                name: 'isNewAccount',
                label: 'Is New Account',
                answer: {
                    type: 'select',
                    choices: [
                        {
                            value: true,
                            text: 'Yes'
                        }, {
                            value: false,
                            text: 'No'
                        }
                    ]

                },
                target: `${target}[${section.index}].isNewAccount`
            },
        ],
        {
            name: 'creditLimit',
            label: 'Credit Limit',
            answer: {
                type: 'euro'
            },
            target: `${target}[${section.index}].creditLimit`,
        },
        {
            name: 'highestCreditUtilisation',
            label: 'Highest Credit Utilisation',
            answer: {
                type: 'euro'
            },
            target: `${target}[${section.index}].highestCreditUtilisation`,
        },
        {
            name:'currency',
            label: 'Currency',
            answer: {
                type: 'text'
            },
            target: `${target}[${section.index}].currency`
        }
    ]
    return (
        <MortgageForm inExtWindow={inExtWindow} questions={questions}/>
    );
}

export default ApplicationForm;